import { createFileRoute } from "@tanstack/react-router"
import { useMemo } from "react"

import { WorkspacePage } from "~/components/design-system/pages"
import { useAllocationPlanning } from "~/components/prototype/allocation-planning/AllocationPlanningContext"
import { AllocationInspector } from "~/components/prototype/allocation-planning/AllocationInspector"
import ReplenishmentTab from "~/components/prototype/allocation-planning/ReplenishmentTab"

export const Route = createFileRoute("/_auth/allocation/_layout/replenishment")({
  component: RouteComponent,
})

function RouteComponent() {
  const { addToCart } = useAllocationPlanning()
  const inspector = useMemo(() => <AllocationInspector />, [])
  return (
    <WorkspacePage contentClassName="p-0" inspector={inspector}>
      <ReplenishmentTab onAddToCart={addToCart} />
    </WorkspacePage>
  )
}
